import { Link } from 'react-router-dom';
import NewsCard from '@/components/feature/NewsCard';
import SectionHeading from '@/components/base/SectionHeading';
import { news } from '@/mocks/news';
import { comics } from '@/mocks/comics';

const RANK_LIMIT = 6;

export default function NewsAndRanking() {
  const featured = news[0];
  const rest = news.slice(1, 5);
  const ranked = [...comics].sort((a, b) => b.popularity - a.popularity).slice(0, RANK_LIMIT);

  return (
    <section className="w-full px-4 md:px-8">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <SectionHeading title="动漫资讯精选" subtitle="及时掌握最新动漫动态与行业观察" moreTo="/category/news" />
          <Link
            to={`/detail/news/${featured.id}`}
            className="group flex cursor-pointer flex-col gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 sm:flex-row"
          >
            <div className="h-48 w-full shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-40 sm:w-72">
              <img
                src={featured.cover}
                alt={`${featured.title}配图`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex min-w-0 flex-1 flex-col">
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded-md bg-accent-500 px-2 py-0.5 text-xs font-label font-700 text-foreground-950">
                  {featured.category}
                </span>
                <span className="text-xs font-label text-foreground-500">{featured.date}</span>
              </div>
              <h3 className="mt-2 line-clamp-2 font-heading text-lg font-700 leading-snug text-foreground-950 group-hover:text-primary-700">
                {featured.title}
              </h3>
              <p className="mt-2 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">{featured.summary}</p>
              <span className="mt-2 text-xs font-label text-foreground-500">来源：{featured.source}</span>
            </div>
          </Link>

          <div className="mt-4 flex flex-col gap-3">
            {rest.map((item) => (
              <NewsCard key={item.id} item={item} />
            ))}
          </div>
        </div>

        <aside className="flex flex-col gap-6">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <h2 className="mb-4 flex items-center gap-2 font-heading text-lg font-800 text-foreground-950">
              <i className="ri-fire-fill text-accent-500" />
              作品排行榜
            </h2>
            <ol className="flex flex-col gap-1">
              {ranked.map((comic, i) => (
                <li key={comic.id}>
                  <Link
                    to={`/detail/comics/${comic.id}`}
                    className="group flex cursor-pointer items-center gap-3 rounded-md p-2 transition-colors hover:bg-background-100"
                  >
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-700 ${
                        i < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      {i + 1}
                    </span>
                    <span className="h-12 w-9 shrink-0 overflow-hidden rounded-md bg-background-200">
                      <img src={comic.cover} alt={`${comic.title}封面`} className="h-full w-full object-cover object-top" />
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block truncate text-sm font-500 text-foreground-900 group-hover:text-primary-700">
                        {comic.title}
                      </span>
                      <span className="text-xs font-label text-foreground-500">
                        热度 {comic.popularity} · {comic.status}
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
          </div>

          <div className="rounded-lg border border-background-200 bg-secondary-50 p-5">
            <h2 className="mb-3 flex items-center gap-2 font-heading text-lg font-800 text-foreground-950">
              <i className="ri-price-tag-3-line text-primary-600" />
              热门标签
            </h2>
            <div className="flex flex-wrap gap-2">
              {['热血', '科幻', '恋爱', '日常', '奇幻', '悬疑', '古风', '搞笑', '治愈', '校园'].map((tag) => (
                <Link
                  key={tag}
                  to={`/category/comics?genre=${encodeURIComponent(tag)}`}
                  className="cursor-pointer rounded-md bg-background-50 px-3 py-1.5 text-xs font-label text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-800"
                >
                  #{tag}
                </Link>
              ))}
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}